import { AccountClient, GET_CLIENTS, GET_SERVICE_ITEMS } from '@nile/graphql';
import { getTranslatedText } from '@nile/components';

export const getClient = (field) => {
  return AccountClient;
};

export const getVariables = (field) => {
  switch (field) {
    // case 'chargeItemId':
    //   return {
    //     listInfo: {}
    //   };
    case 'clientId':
      return { listInfo: {} };
    default:
      return undefined;
  }
};

export const getQuery = (field) => {
  switch (field) {
    // case 'chargeItemId':
    //   return GET_SERVICE_ITEMS;
    case 'clientId':
      return GET_CLIENTS;
    default:
      return null;
  }
};

export const callQuery = (field) => {
  const query = getQuery(field);
  const client = getClient(field);
  const variables = getVariables(field);

  switch (field) {
    // case 'chargeItemId':
    case 'clientId':
      return client?.query({ query, variables });
    default:
      return [];
  }
};

export const getSelectOptions = (field) => {
  switch (field) {
    default:
      return [];
  }
};

const getQueryName = (field) => {
  switch (field) {
    // case 'chargeItemId':
    //   return 'getServiceItems';
    case 'clientId':
      return 'getClientList';
    default:
      return null;
  }
};

export const shapeOptions = (field, options) => {
  const key = getQueryName(field);
  switch (field) {
    // case 'chargeItemId':
    //   return options?.data?.[key].items
    //     .filter((el) => {
    //       return el?.quantityType !== 'HOURS';
    //     })
    //     .map((el) => {
    //       return {
    //         value: el.itemId,
    //         label: el.name,
    //         quantityType: el.quantityType
    //       };
    //     });
    case 'clientId':
      return options?.data?.[key].clients.map((el) => {
        return {
          value: el.accountId,
          label: el.name
        };
      });
    default:
      return options;
  }
};

const getFrequencyQuantities = () => {
  const frequencyQuantityArray = [];
  for (let i = 1; i <= 31; i++) {
    frequencyQuantityArray.push({
      label: `${i}`,
      value: `${i}`
    });
  }
  return frequencyQuantityArray;
};

export const getClientContractImportFields = (intl) => [
  {
    label: 'dromo.title.clientName',
    key: 'clientId',
    type: 'select',
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'client.details.contractType',
    key: 'contractType',
    type: 'select',
    selectOptions: [
      {
        label: 'Recurring Contract',
        value: 'SERVICE'
      },
      {
        label: 'Usage based contract',
        value: 'USAGE'
      }
    ],
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'entityAttribute.serviceItem.name',
    key: 'chargeItemId',
    type: 'select',
    selectOptions: [],
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'common.description',
    key: 'description'
  },
  {
    label: 'Contract selling price calculation type',
    key: 'sellingPriceCalculationType',
    type: 'select',
    selectOptions: [
      {
        label: 'Fixed',
        value: 'FIXED'
      },
      {
        label: 'Dynamic',
        value: 'DYNAMIC'
      }
    ],
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'msp.contracts.form.field.override.price',
    key: 'sellingPriceOverridden',
    type: 'select',
    selectOptions: [
      {
        label: 'app.common.true',
        value: 'true'
      },
      {
        label: 'app.common.false',
        value: 'false'
      }
    ]
  },
  {
    label: 'msp.contracts.form.field.pricingOverride.table.newPrice',
    key: 'sellingPrice',
    type: [
      'number',
      {
        round: 4
      }
    ]
  },
  {
    label: 'invoice.details.billedTo',
    key: 'billableSiteType',
    type: 'select',
    selectOptions: [
      {
        label: 'HQ',
        value: 'HQ'
      },
      {
        label: 'All Sites',
        value: 'ALL'
      },
      {
        label: 'Specific Sites',
        value: 'INCLUDED'
      }
    ],
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'provisionRule.name.sites',
    key: 'addSites',
    description: getTranslatedText(intl, 'dromo.description.multiSelectItems', {
      fieldName: 'Sites'
    })
  },
  {
    label: 'dromo.title.contractStartDate',
    key: 'startDate',
    type: [
      'date',
      {
        displayFormat: 'yyyy-MM-dd'
      }
    ],
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'dromo.title.contractEndDate',
    key: 'endDate',
    type: [
      'date',
      {
        displayFormat: 'yyyy-MM-dd'
      }
    ]
  },
  {
    label: 'dromo.title.remindBeforeExpiry',
    key: 'remindDuration',
    type: [
      'number',
      {
        round: 0
      }
    ]
  },
  {
    label: 'Quantity calculation type',
    key: 'quantityCalculationType',
    type: 'select',
    selectOptions: [
      {
        label: 'Fixed',
        value: 'FIXED'
      },
      {
        label: 'Dynamic',
        value: 'DYNAMIC'
      }
    ],
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'admin.integrations.map.serviceItemType.serviceQuantity',
    key: 'quantity',
    type: [
      'number',
      {
        round: 0
      }
    ]
  },
  {
    label: 'msp.contracts.form.field.select.billing.group',
    key: 'provisionRuleId',
    type: 'select',
    selectOptions: []
  },
  {
    label: 'msp.contracts.form.field.add.discount',
    key: 'discountRate',
    type: [
      'number',
      {
        round: 0,
        min: 0,
        max: 99
      }
    ]
  },
  {
    label: 'admin.serviceCatalog.carryForwardRemainingHours',
    key: 'carryForwardRemainingQuantity',
    type: 'select',
    selectOptions: [
      {
        label: 'TRUE',
        value: 'true'
      },
      {
        label: 'FALSE',
        value: 'false'
      }
    ]
  },
  {
    label: 'dromo.title.subscription.term',
    key: 'frequencyDurationUnit',
    type: 'select',
    selectOptions: [
      {
        label: 'Month',
        value: 'MONTH'
      },
      {
        label: 'Days',
        value: 'DAY'
      },
      {
        label: 'Week',
        value: 'WEEK'
      },
      {
        label: 'Year',
        value: 'YEAR'
      }
    ]
  },
  {
    label: 'msp.contracts.form.field.subscription.period',
    key: 'frequencyInterval',
    type: [
      'number',
      {
        round: 0
      }
    ]
  },
  {
    label: 'msp.contracts.form.field.subscription.frequency',
    key: 'frequencyType',
    type: 'select',
    selectOptions: [
      // {
      //   label: 'Once',
      //   value: 'ONCE'
      // },
      {
        label: 'Perpetual',
        value: 'PERPETUAL'
      },
      {
        label: 'Recurring',
        value: 'RECURRING'
      }
    ],
    validators: [
      {
        validate: 'required',
        errorMessage: 'dromo.validation.requiredField'
      }
    ]
  },
  {
    label: 'admin.serviceCatalog.autoRenew',
    key: 'autoRenew',
    type: 'select',
    selectOptions: [
      {
        label: 'TRUE',
        value: 'true'
      },
      {
        label: 'FALSE',
        value: 'false'
      }
    ]
  },
  {
    label: 'msp.contracts.form.field.subscription.method',
    key: 'recurringMode',
    type: 'select',
    selectOptions: [
      {
        label: 'Arrear',
        value: 'ARREAR'
      },
      {
        label: 'Upfront',
        value: 'UPFRONT'
      },
      {
        label: 'Advance',
        value: 'ADVANCE'
      }
    ]
  },
  {
    label: 'client.details.contractinvoice.recurringMode.advanced.bellBefore',
    key: 'billingOffset',
    type: [
      'number',
      {
        round: 0
      }
    ]
  },
  // {
  //   label: 'client.contracts.item.effectiveDate',
  //   key: 'effectiveDate',
  //   validators: [
  //     {
  //       validate: 'regex_match',
  //       regex:
  //         '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(Z)?$',
  //       errorMessage: 'dromo.validation.date'
  //     }
  //   ]
  // },
  {
    label: 'dromo.title.included.items',
    key: 'addIncludedItems'
  }
];
